import { render, staticRenderFns } from "./inventorySyncRulesModal.vue?vue&type=template&id=57411525&scoped=true"
import script from "./inventorySyncRulesModal.vue?vue&type=script&lang=js"
export * from "./inventorySyncRulesModal.vue?vue&type=script&lang=js"
import style0 from "./inventorySyncRulesModal.vue?vue&type=style&index=0&id=57411525&prod&lang=css"
import style1 from "./inventorySyncRulesModal.vue?vue&type=style&index=1&id=57411525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57411525",
  null
  
)

export default component.exports